import React, { useEffect, useMemo, useState } from "react";
import Modal from '../../components/UI/Modal/Modal';
import { FaTimes, FaSpinner } from 'react-icons/fa';
import Spinner from "../../components/UI/Spinner/Spinner";
import classes from "./MultiRouterAccount.css";

const PodCard = (props) => {
  const { pod, networkTopology, assignPod, assignPodSuccess, assignPodFailure, isAssignPodRequestLoading } = props;
  const pSerial = pod.serialNumber;
  const [isAssignPodModalOpen, setIsAssignPodModalOpen] = useState(false)
  const [ssid, setSsid] = useState("")
  const [rMac, setRMac] = useState("")

  useEffect(() => {
    if(isAssignPodModalOpen && (assignPodFailure || assignPodSuccess)){
      closeAssignPodModal()
    }
  }, [assignPodFailure, assignPodSuccess])
  // console.log(props, 'props')
  const closeAssignPodModal = () => {
    setIsAssignPodModalOpen(false);
    setSsid("");
  };
  const handleSsidChange = (event) => {
    // console.log("EVENT", event);
    setSsid(event?.router?.oneSsid);
    setRMac(event?.router?.mac);
  };
  // console.log(ssid, 'ssid')
  const connectedStatus = pod?.connectionState || 'N/A'
 
  // const ssidData = useMemo(() => {
  //   let data = [];
  //   networkTopology.forEach(topology => {
  //     if (topology.router && topology.router.oneSsid) {
  //       data = [...data, topology.router.ssid]
  //     }
  //   });
  //   return data;
  // }, [networkTopology])


  return (
    <div className={classes.boxWrapper}>
      <div className={classes.podBox}>
        <div className={classes.routerHeading}>
          <h1 id='PodHeader' >Extender</h1>
        </div>

        <div id='ABWPodModel' className={classes.field}>Model: {pod.model}</div>
        <div id='ABWPodStatus' className={classes.field}>SerialNumber: {pod.serialNumber}</div>
      </div>
      <div>
        <button
          id='ABWAssignPod'
          className={classes.viewDetails}
          disabled={isAssignPodModalOpen}
          onClick={() => setIsAssignPodModalOpen(true)}
        >
          Assign Extender
        </button>
      </div>
    {isAssignPodModalOpen &&
      <Modal show={isAssignPodModalOpen} modalClosed={closeAssignPodModal}>
        <div className={classes.assignPodModal}>
          <div style={{ display: 'flex', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h3 id='AssignPodTxt' style={{ margin: 0 }}>Assign Extender</h3>
              <span id='SelectSSIDTxt' style={{ fontSize: '0.85rem', color: 'grey'}}>Select 1 SSID</span>
            </div>
            <span id='X'
              onClick={closeAssignPodModal}
              style={{ position: 'absolute', right: 0, top: 0 }}
            ><FaTimes color='#555555' cursor='pointer' size={20} />
            </span>
          </div>
          {(isAssignPodRequestLoading) ? 
          <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
            <Spinner/>
            <div id = 'AssigingPodTxt' >Assigning Extender please wait...</div>

        </div> : 
        <React.Fragment>
          <div>
            {networkTopology?.map((topo, index) => {
              if (topo?.router?.oneSsid) {
                // console.log("ssidValue", topo.router.oneSsid)
                return (
                  <div className={classes.assignModalInputContainer} key={index}>
                    <input
                      type="radio"
                      //  id={`${ssidValue}_${index}`} 
                      id='SSIDRadioBtn' 
                      name="ssid"
                      value={topo.router.oneSsid}
                      onChange={() => handleSsidChange(topo)}
                      defaultChecked={ssid === topo.router.oneSsid}
                      aria-label={"SSID Radio Button"}
                    />
                    <label htmlFor={`${topo.router.oneSsid}_${index}`} className={classes.ssidLabel}>
                      <span id='PodSSIDName' className={classes.ssidName}>{topo.router.oneSsid}</span>
                      <span id='PodSSIDMac' className={classes.macAddress}>MAC: {topo.router.mac || 'N/A'}</span>
                    </label>
                  </div>
                )
              }
            })}
          </div>

          <div className={classes.ButtonRow}>
            <button
              id='ABWcancel'
              className={classes.CancelButton}
              onClick={closeAssignPodModal}
              btnType="Success">
              Cancel</button>
            <button
              id='ABWAssign'
              className={classes.Button}
              onClick={() => assignPod(pSerial, rMac, ssid)}
              disabled={!ssid}
              btnType="Success">
              Assign</button>

          </div>
        </React.Fragment>}
        </div>
      </Modal>
}
    </div>
  );
};

export default PodCard;
